"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M7 4h10V2H7v2zm1.7733 1.513-.6366 2.1664-1.9398-.513L6.8335 5l1.9398.513zm8.4602-.5105-1.9397.513.6229 2.1495 1.9397-.513-.6229-2.1495zm.0638 7.427-.8284-2.8587 1.9397-.513.8284 2.8586-1.9397.5131zm2.492 1.3928-1.9397.513.8284 2.8589 1.9397-.513-.8284-2.8589zm-.559 5.2777 1.9397-.513.83 2.8644-1.9304.545-.8393-2.8964zM5.3392 17.1991l.8393-2.856-1.9399-.5131-.8393 2.856 1.9399.5131zM2.8398 18.59l1.9399.513L3.9283 22 2 21.4478l.8398-2.8578zm1.9583-6.6639 1.9399.5131.8392-2.8559-1.9398-.513-.8393 2.8558z"
  })];
};

exports.default = _default;